module.exports = __webpack_public_path__ + "static/media/roulette.b4b10400.png";